export const AppVersion = "0.0.65.0";
